import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { reducer as campaign } from './campaign';
import { reducer as communication } from './communication';
import { reducer as template } from './template';
import { reducer as user } from './user';
import { reducer as userMessaging } from './userMessaging';
import { reducer as attachmentTemplate } from './attachmentTemplate';
import { reducer as queryTemplate } from './recipientQueryTemplate';
import { reducer as conditionQueryTemplate } from './conditionQueryTemplate';
import { reducer as printTemplate } from './printTemplate';
import { reducer as surveyTemplate } from './surveyTemplate';
import { reducer as survey } from './surveys';
import { reducer as settings } from './settings';
import { reducer as reports } from './reports';
import { reducer as eventReports } from './eventReports';
import { reducer as batches } from './batches';
import { reducer as unSubscribe } from './unSubscribe';
import { reducer as events } from './event';
import { reducer as schema } from './schema';
import { reducer as enrichedSchema } from './enrichedSchema';
import { reducer as tableAndToolbar } from './helpers/tableAndToolbar';
import { reducer as lists } from './lists';
import { reducer as guestInsights } from './guestInsights';
import { reducer as copyTemplateModal } from './copyTemplateModal';
import { reducer as surveyAi } from './surveyAi';
import { reducer as uploads } from './uploads';

export default history =>
  combineReducers({
    router: connectRouter(history),
    campaign,
    communication,
    template,
    user,
    userMessaging,
    attachmentTemplate,
    conditionQueryTemplate,
    queryTemplate,
    printTemplate,
    surveyTemplate,
    survey,
    settings,
    reports,
    eventReports,
    batches,
    unSubscribe,
    events,
    schema,
    enrichedSchema,
    tableAndToolbar,
    lists,
    guestInsights,
    copyTemplateModal,
    surveyAi,
    uploads
  });
